<template>
  <ClModal v-model="active" :blur="true" :persistent="true">
    <v-card rounded class="rounded-xl">
      <div class="course-modal">
        <img src="../../../assets/images/courses/DoreJame6ta91404-Small.jpg">
        <div class="col-two">
          <div class="course-modal-description p-4">
            <h3>دوره جامع هر پايه :</h3>
            <p>تدريس صفر تا صد كتاب درسي</p>
            <p>حل نمونه سوالات تشريحي براي آمادگي امتحانات</p>
            <p>آموزش با شيوه‌هاي جديد و نوين براي يادگيري بهتر دانش‌آموزان</p>
            <p>زمان شروع دوره : ۱۳ مرداد</p>
          </div>
          <div class="btns-box">
            <a class="btn cl-btn cl-btn-blue "
               @click="gotoFilteredCourses('/courses?courses=430%2C427%2C424%2C433&grades=&lessons=&professors=')">نمایش
              دوره‌ها</a>
          </div>
        </div>
      </div>
    </v-card>
  </ClModal>
</template>

<script>
import ClModal from "@/components/common/ClModal.vue";

export default {
  name: "DoreJameDahom1404",
  components: {ClModal},
  props: ['activeCourse'],
  data() {
    return {
      active: false
    }
  },
  mounted() {
    this.active = true
  },
  methods: {
    gotoFilteredCourses(params) {
      this.$router.push(params)
    },
    close() {
      this.active = false;
    }
  },
  watch: {
    activeCourse() {
      this.active = true
    }
  }

}
</script>

<style scoped>
</style>
